/**
 * ลิงก์ข้าม module ไปหน้า "ข้อมูลโครงการ" (/master-data/sites)
 *
 * หน้ารายการโครงการ (SitePage) รับ `company=<company_id>` → กรองรายการเฉพาะโครงการของบริษัทนั้น
 * รายละเอียด/แก้ไข/เพิ่ม เป็นหน้าเต็ม (28 ต.ค. 2026): `/master-data/sites/:id` · `/:id/edit` · `/new`
 * (`?view=<site_id>` เดิม = ลิงก์เก่า → App.tsx เด้งไปหน้ารายละเอียด)
 *
 * ใช้ helper นี้ทุกที่ที่ต้องลิงก์ไปโครงการ (หน้ารายละเอียดซ่อมบำรุง / หน้ารายละเอียดการเช่า ฯลฯ)
 * เพื่อให้ URL contract อยู่ที่เดียว — user feedback 2026-09-05
 */
export const SITES_PATH = '/master-data/sites';

const toPositiveInt = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
};

/** หน้ารายการโครงการ กรองเฉพาะโครงการของบริษัท — id ไม่ถูกต้อง = รายการทั้งหมด */
export function siteListByCompanyUrl(companyId: number | string | null | undefined): string {
  const id = toPositiveInt(companyId);
  return id ? `${SITES_PATH}?company=${id}` : SITES_PATH;
}

/**
 * หน้ารายละเอียดโครงการ `/master-data/sites/:id` (หน้าเต็มตั้งแต่ 28 ต.ค. 2026 — เดิมเปิดโมดัลด้วย `?view=`)
 * `companyId` คงไว้เพื่อความเข้ากันได้ของผู้เรียกเดิม: siteId ไม่ถูกต้อง = ถอยไปหน้ารายการ (กรองบริษัทถ้ามี)
 * ลิงก์เก่า `?view=<id>` ยังเปิดได้ — LegacyDetailRedirect ใน App.tsx เด้งมาหน้านี้
 */
export function siteDetailUrl(
  siteId: number | string | null | undefined,
  companyId?: number | string | null,
): string {
  const sid = toPositiveInt(siteId);
  if (!sid) return siteListByCompanyUrl(companyId);
  return `${SITES_PATH}/${sid}`;
}

/** หน้าแก้ไขโครงการ (sites.view + sites.edit) — id ไม่ถูกต้อง = หน้ารายการ */
export function siteEditUrl(siteId: number | string | null | undefined): string {
  const sid = toPositiveInt(siteId);
  return sid ? `${SITES_PATH}/${sid}/edit` : SITES_PATH;
}

/** หน้าเพิ่มโครงการ (sites.create) */
export const SITE_NEW_URL = `${SITES_PATH}/new`;
